export const GET_PREVIEW_MEDIA_REQUEST_INIT = 'GET_PREVIEW_MEDIA_REQUEST_INIT';
export const GET_PREVIEW_GET_MEDIA_REQUEST_SUCCESS =
  'GET_PREVIEW_GET_MEDIA_REQUEST_SUCCESS';
export const GET_PREVIEW_GET_MEDIA_REQUEST_ERROR =
  'GET_PREVIEW_GET_MEDIA_REQUEST_ERROR';

export const CLEAR_PREVIEW_CONTENT_MEDIA = 'CLEAR_PREVIEW_CONTENT_MEDIA';
